import React, { forwardRef, useState, useEffect, LegacyRef } from 'react';
import axios from 'axios';
import Processing from '../Processing/Processing';
import styles from './GuideImg.module.css';

const GuideImg = forwardRef(
	(
		{
			imageRef,
			imgSrc,
			step,
			token,
			imageReadyState,
			setImageReadyState,
			onLoadedImage,
			onLoadImageError,
			onFocus,
			onBlur,
			floIndex,
		}: {
			imageRef: LegacyRef<HTMLImageElement>;
			imgSrc: string;
			step: any;
			token?: string;
			imageReadyState: 'loading' | 'loaded' | 'errored';
			setImageReadyState: (state: 'loading' | 'loaded' | 'errored') => void;
			onLoadedImage: () => void;
			onLoadImageError: () => void;
			onFocus: () => void;
			onBlur: () => void;
			floIndex: number;
		},
		ref
	) => {
		const [imageUrl, setImageUrl] = useState('');
		const embeddedElements = document.querySelectorAll('floik-flo');
		const region =
			embeddedElements.length > 0
				? embeddedElements[floIndex].getAttribute('doc360-region')
				: '';
		const deploymentId =
			embeddedElements.length > 0
				? embeddedElements[floIndex].getAttribute('doc360-deployment-id') || ''
				: '';

		useEffect(() => {
			if (imageReadyState === 'errored') {
				setImageUrl(imgSrc);
				return;
			}

			if (imageReadyState !== 'loading') return;

			const fetchImage = async () => {
				if (token) {
					try {
						const response = await axios.get(imgSrc, {
							headers: {
								Authorization: 'Bearer ' + token,
								// 'x-d360-id': deploymentId.split('-')[0],
								'x-d360-id': deploymentId,
								'x-d360-region': region,
							},
							responseType: 'blob',
						});

						const imageUrl = URL.createObjectURL(response.data);
						setImageReadyState('loaded');
						setImageUrl(imageUrl);
					} catch (error) {
						setImageReadyState('errored');
						if (onLoadImageError) onLoadImageError();
					}
				} else {
					setImageUrl(imgSrc);
				}
			};

			fetchImage();
		}, [
			imgSrc,
			token,
			setImageUrl,
			imageReadyState,
			setImageReadyState,
			onLoadImageError,
		]);

		return imageUrl ? (
			<img
				style={{
					display: imageReadyState !== 'loading' ? 'block' : 'none',
				}}
				className={styles.imgTag}
				tabIndex={0}
				ref={imageRef}
				src={imageUrl}
				alt={step?.title || 'Guide Image'}
				onLoad={onLoadedImage}
				onError={onLoadImageError}
				onFocus={onFocus}
				onBlur={onBlur}
			/>
		) : imageReadyState === 'loading' ? (
			<Processing text={'Loading...'} />
		) : null;
	}
);

export default GuideImg;
